import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import DateFormat from 'constants/date_format';

const EventCard = ({ event, setSelectedEvent, previewing }) => {
  const date = moment(event.next_session.start_time);
  const monthFormatted = date.format(DateFormat.fixed.LONG_MONTH);
  const dayFormatted = date.format(DateFormat.fixed.NUMBER_DAY);
  const hasMultipleSessions = event.number_of_sessions > 1;
  const moreSessionsCount = hasMultipleSessions
    ? event.number_of_sessions - 1
    : null;

  const handleCardSelection = () => {
    setSelectedEvent(event);
  };

  return (
    <div
      role="button"
      className="EventItem--card d-f p-16"
      onClick={handleCardSelection}
      onKeyDown={e => {
        if (e.keycode === 13 || e.code === 'Enter') {
          handleCardSelection();
        }
      }}
      tabIndex={0}
    >
      <div className="EventItem--date d-f jc-c ai-c fd-c">
        <Text variant={TEXT_VARIANTS.BODY} className="ta-c month">
          {monthFormatted}
        </Text>
        <Text variant={TEXT_VARIANTS.TITLE} className="ta-c day">
          {dayFormatted}
        </Text>
      </div>
      <div className="EventItem--info pl-16">
        <Text variant={TEXT_VARIANTS.BODY_BOLD} className="ta-c mb-4">
          {event.name}
        </Text>
        <SessionDetails
          session={event.next_session}
          eventId={event.id}
          showRegistrationCap
          hasMultipleSessions={hasMultipleSessions}
          moreSessionsCount={moreSessionsCount}
          previewing={previewing}
        />
      </div>
    </div>
  );
};

export default EventCard;
